import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ScrollReveal } from '../components/ui/ScrollReveal';
import { Button } from '../components/ui/Button';
export function ResortsPage() {
  return <div className="w-full pt-24" data-id="element-1037">
      <section className="py-24 md:py-32 bg-brand-green-deep text-brand-cream-light relative overflow-hidden" data-id="element-1038">
        <div className="absolute inset-0 bg-concept-resort opacity-30 mix-blend-overlay" data-id="element-1039" />
        <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-1040">
          <SectionHeading eyebrow="Resorts & Hospitality" title="Guest-facing golf experiences that drive engagement." subtitle="Turn unused space into a social, shareable amenity that keeps guests on property longer." light data-id="element-1041" />
        </div>
      </section>

      <section className="py-24 bg-brand-cream-light" data-id="element-1042">
        <div className="max-w-7xl mx-auto px-6" data-id="element-1043">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-1044">
            <ScrollReveal delay={0.1} data-id="element-1045">
              <h3 className="text-2xl font-heading text-brand-green-deep mb-4" data-id="element-1046">
                Family & Social Play
              </h3>
              <p className="text-brand-stone font-body" data-id="element-1047">
                An accessible, high-end activity that appeals to golfers and
                non-golfers alike, perfect for afternoon downtime or
                after-dinner drinks.
              </p>
            </ScrollReveal>
            <ScrollReveal delay={0.2} data-id="element-1048">
              <h3 className="text-2xl font-heading text-brand-green-deep mb-4" data-id="element-1049">
                Wedding & Event Feature
              </h3>
              <p className="text-brand-stone font-body" data-id="element-1050">
                A unique activation for wedding weekends, corporate retreats,
                and private events that photographs beautifully.
              </p>
            </ScrollReveal>
            <ScrollReveal delay={0.3} data-id="element-1051">
              <h3 className="text-2xl font-heading text-brand-green-deep mb-4" data-id="element-1052">
                Content Engine
              </h3>
              <p className="text-brand-stone font-body" data-id="element-1053">
                Designed to be highly visual and shareable, generating organic
                social media content from your guests.
              </p>
            </ScrollReveal>
          </div>
        </div>
      </section>

      <section className="py-24 bg-brand-charcoal text-brand-cream-light" data-id="element-1054">
        <div className="max-w-7xl mx-auto px-6 text-center" data-id="element-1055">
          <ScrollReveal data-id="element-1056">
            <h2 className="text-4xl font-heading mb-6" data-id="element-1057">
              Powered by PuttLab Play
            </h2>
            <p className="text-xl font-body text-brand-cream/80 max-w-2xl mx-auto mb-12" data-id="element-1058">
              Add our QR-enabled digital layer to allow guests to keep score,
              compete on resort-wide leaderboards, and share branded winner
              cards.
            </p>
            <Button variant="primary" href="/play" data-id="element-1059">
              Learn about PuttLab Play
            </Button>
          </ScrollReveal>
        </div>
      </section>
    </div>;
}